import { fmt } from "@/lib/api";
import { useNow, sessionOf, nextCandleSecs, fmtDur } from "@/lib/terminalUtils";
import { market } from "@/lib/symbols";

export const OverviewPanel = ({ sig, symbol, onSelect, symbols }) => {
  const now = useNow();
  const up = (sig?.change_pct ?? 0) >= 0;
  return (
    <div className="border border-white/10 bg-[#0d1219] p-4" data-testid="overview-panel">
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Market Overview</p>
      <div className="mt-3 flex items-center justify-between">
        <select value={symbol} onChange={(e) => onSelect(e.target.value)} data-testid="symbol-select"
          className="border border-white/15 bg-ink px-2 py-1.5 font-mono text-base font-bold text-white outline-none">
          {symbols.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <span className="flex items-center gap-1.5 font-mono text-[10px] font-bold text-buy">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-buy" /> LIVE
        </span>
      </div>
      <p className="mt-1 font-mono text-[10px] text-mute-dim">{market[symbol]?.name}</p>
      <div className="mt-2 font-display text-3xl font-black text-white" data-testid="overview-price">
        {sig ? fmt(sig.price, market[symbol]?.d ?? 2) : "—"}
      </div>
      <p className={`font-mono text-xs ${up ? "text-buy" : "text-sell"}`}>
        {up ? "+" : ""}{sig?.change_pct ?? 0}% /24j
      </p>
      <div className="mt-4 space-y-2 border-t border-white/5 pt-3 font-mono text-xs">
        <div className="flex justify-between"><span className="text-mute">Session</span><span className="text-white">{sessionOf(now)}</span></div>
        <div className="flex justify-between"><span className="text-mute">Candle</span><span className="text-white">{sig?.candle_source?.includes("twelvedata") ? "Yahoo + TwelveData 1m" : "Yahoo 15m"}</span></div>
        <div className="flex justify-between"><span className="text-mute">Spread</span><span className="text-white">{sig?.spread_live ?? market[symbol]?.spread}{sig?.spread_live != null && <span className="ml-1 text-[9px] text-buy">live</span>}</span></div>
        <div className="flex justify-between"><span className="text-mute">Next Candle</span><span className="text-buy">{fmtDur(nextCandleSecs(now))}</span></div>
        <div className="h-1 w-full bg-white/5">
          <div className="h-full bg-buy transition-all duration-1000" style={{ width: `${(nextCandleSecs(now) / 900) * 100}%` }} />
        </div>
      </div>
    </div>
  );
};
